// Generated by Melange

import * as Curry from "melange.js/curry.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__ListLabels from "melange/listLabels.js";
import * as Stdlib__Printf from "melange/printf.js";
import * as Stdlib__StringLabels from "melange/stringLabels.js";

function to_string(param) {
  if (typeof param === "string") {
    return "null";
  }
  const variant = param.NAME;
  if (variant === "Int") {
    return String(param.VAL);
  } else if (variant === "Float") {
    return Stdlib.string_of_float(param.VAL);
  } else if (variant === "Bool") {
    return Stdlib.string_of_bool(param.VAL);
  } else if (variant === "List") {
    return Curry._1(Stdlib__Printf.sprintf(/* Format */{
                    _0: {
                      TAG: /* String_literal */11,
                      _0: "[ ",
                      _1: {
                        TAG: /* String */2,
                        _0: /* No_padding */0,
                        _1: {
                          TAG: /* String_literal */11,
                          _0: " ]",
                          _1: /* End_of_format */0
                        }
                      }
                    },
                    _1: "[ %s ]"
                  }), Stdlib__StringLabels.concat(", ", Stdlib__ListLabels.map(to_string, param.VAL)));
  } else if (variant === "Assoc") {
    return Curry._1(Stdlib__Printf.sprintf(/* Format */{
                    _0: {
                      TAG: /* String_literal */11,
                      _0: "{ ",
                      _1: {
                        TAG: /* String */2,
                        _0: /* No_padding */0,
                        _1: {
                          TAG: /* String_literal */11,
                          _0: " }",
                          _1: /* End_of_format */0
                        }
                      }
                    },
                    _1: "{ %s }"
                  }), Stdlib__StringLabels.concat(", ", Stdlib__ListLabels.map((function (param) {
                          return Curry._2(Stdlib__Printf.sprintf(/* Format */{
                                          _0: {
                                            TAG: /* Char_literal */12,
                                            _0: /* '"' */34,
                                            _1: {
                                              TAG: /* String */2,
                                              _0: /* No_padding */0,
                                              _1: {
                                                TAG: /* String_literal */11,
                                                _0: "\": ",
                                                _1: {
                                                  TAG: /* String */2,
                                                  _0: /* No_padding */0,
                                                  _1: /* End_of_format */0
                                                }
                                              }
                                            }
                                          },
                                          _1: "\"%s\": %s"
                                        }), param[0], to_string(param[1]));
                        }), param.VAL)));
  } else {
    return Curry._1(Stdlib__Printf.sprintf(/* Format */{
                    _0: {
                      TAG: /* Char_literal */12,
                      _0: /* '"' */34,
                      _1: {
                        TAG: /* String */2,
                        _0: /* No_padding */0,
                        _1: {
                          TAG: /* Char_literal */12,
                          _0: /* '"' */34,
                          _1: /* End_of_format */0
                        }
                      }
                    },
                    _1: "\"%s\""
                  }), param.VAL);
  }
}

export {
  to_string ,
}
/* No side effect */
